import * as React from "react";
import { StockIndicator } from "@grandvisionhq/inventory";
import { getCalculatedMaximumQuantity } from "@grandvisionhq/utils";
import { ProductQuantitySelector } from "../../../../../../../../components/ProductQuantitySelector/modules/EcommContent/components/ProductQuantitySelector/ProductQuantitySelector.js";
import { pushSolutionsChangeQuantityEvent } from "../../../../../../../../../Analytics/events/modules/Analytics/events/change-quantity-events.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { useSolutionsEcommContext } from "../../../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
const SolutionsQuantityAndStock = () => {
  const { activeVariant, selectedPurchaseType } = useProductData();
  const { actions, state, maxOrderableQuantity } = useSolutionsEcommContext();
  const { channelAvailability, stock } = activeVariant;
  const { quantity: selectedQuantity } = state.configurations;
  const maxSelectableQuantity = getCalculatedMaximumQuantity(
    maxOrderableQuantity,
    stock.stockCount,
    stock.isAllowBackOrder
  );
  const onQuantityChange = (quantity, type) => {
    actions.updateQuantity(quantity);
    pushSolutionsChangeQuantityEvent({
      quantity,
      quantityChange: type,
      purchaseType: selectedPurchaseType
    });
  };
  const onIncreaseQuantity = () => {
    const quantity = selectedQuantity + 1;
    onQuantityChange(quantity, "increase");
  };
  const onDecreaseQuantity = () => {
    const quantity = selectedQuantity - 1;
    onQuantityChange(quantity, "decrease");
  };
  if (channelAvailability !== "ONLINE") {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ProductQuantitySelector,
    {
      className: "solutions-quantity-and-stock",
      quantity: selectedQuantity,
      maximumQuantity: maxSelectableQuantity,
      onDecreaseQuantity,
      onIncreaseQuantity
    },
    /* @__PURE__ */ React.createElement(
      StockIndicator,
      {
        stockCount: stock.stockCount,
        allowBackOrder: stock.isAllowBackOrder,
        channelAvailability
      }
    )
  );
};
export {
  SolutionsQuantityAndStock
};
//# sourceMappingURL=SolutionsQuantityAndStock.js.map
